import createLucideIcon from '../createLucideIcon';

const AlignRight = createLucideIcon('AlignRightIcon', [
  ['line', { x1: '21', y1: '6', x2: '3', y2: '6', key: '1e448z' }],
  ['line', { x1: '21', y1: '12', x2: '9', y2: '12', key: '1stwgr' }],
  ['line', { x1: '21', y1: '18', x2: '7', y2: '18', key: '1hion3' }],
]);

export default AlignRight;
